function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "filter-1"
}, /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceGraphic",
  type: "matrix",
  values: 0
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "admin",
  stroke: "none",
  strokeWidth: 0,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "landingpage01",
  transform: "translate(-55.000000, -524.000000)",
  fill: "#333333"
}, /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter-1)",
  id: "compass"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(54.000000, 523.000000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M12,1 C18.0751322,1 23,5.92486775 23,12 C23,18.0751322 18.0751322,23 12,23 C5.92486775,23 1,18.0751322 1,12 C1,5.92486775 5.92486775,1 12,1 Z M12,3 C7.02943725,3 3,7.02943725 3,12 C3,16.9705627 7.02943725,21 12,21 C16.9705627,21 21,16.9705627 21,12 C21,7.02943725 16.9705627,3 12,3 Z M17.1886833,8.07622777 L15.0686833,14.4362278 C14.9691483,14.7348328 14.7348328,14.9691483 14.4362278,15.0686833 L8.07622777,17.1886833 C7.29446974,17.4492693 6.55073069,16.7055303 6.8113167,15.9237722 L8.9313167,9.56377223 C9.0308517,9.26516724 9.26516724,9.0308517 9.56377223,8.9313167 L15.9237722,6.8113167 C16.7055303,6.55073069 17.4492693,7.29446974 17.1886833,8.07622777 Z M14.6588612,9.34113883 L10.6705694,10.6705694 L9.34113883,14.6588612 L13.3294306,13.3294306 L14.6588612,9.34113883 Z",
  id: "icon",
  fill: "#000"
})))));

var SvgStartups = function SvgStartups(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "22px",
    viewBox: "0 0 22 22",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgStartups, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/startups.5c273761.svg";
export { ForwardRef as ReactComponent };